module.exports = __webpack_public_path__ + "static/app-shot-1-3-ce9e7b04eac544cd219e6b3341f32e28.jpg";